// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6df72b26","977":"0f0cff20"}[chunkId] + ".chunk.js";
};